module.exports = __webpack_public_path__ + "img/slide-button-links.de106c19661a9c230382f7c0e0aa8017.svg";